module.exports = __webpack_public_path__ + "static/media/Skier.6ca02cc9.jpg";